import { updateSubscriptionPrice } from 'client/api/subscriptionManagement'

import * as api from '../api/company'
import { TABS } from '../components/Modal/CompanyInformationModal/CompanyInformationModal'
import { CompanyInterface, CompanyPlatformInterface, VatNumberValidation } from '../Interfaces/CompanyInterface'
import { CompanyActions } from './actionTypes'
import { actionCreator, actionCreatorAsync, AsyncAction } from './index'
import { changeLocale } from './language'
import { navigateAddModal } from './navigation'

export function getCompany(): AsyncAction<CompanyInterface> {
  return actionCreatorAsync<CompanyInterface>('GET_COMPANY', async () => {
    return Promise.resolve(await api.getCompany())
  })
}

export function getCompanySettings() {
  return actionCreatorAsync('GET_COMPANY_SETTINGS', async () => {
    return Promise.resolve(await api.getCompanySettings())
  })
}

export function openCompanyModal(next) {
  return async (dispatch, getState) => {
    dispatch(
      navigateAddModal({
        component: 'CompanyInformationModal',
        props: {
          activeTab: TABS.companyDetails,
          tradeNameId: getState().settings.values?.company.tradeNames[0]._id,
          next,
        },
      }),
    )
  }
}

export const updateCompany = (company: CompanyInterface, isNotVATLiable?: boolean, updateStripeClient?: boolean) => {
  return async (dispatch, getState) => {
    const prevLanguage = getState().company.language
    return dispatch(
      actionCreatorAsync<CompanyPlatformInterface>('COMPANY_UPDATE', async () => {
        const updatedCompany = await api.updateCompany({ ...company })
        if (prevLanguage !== updatedCompany.language) {
          dispatch(changeLocale(updatedCompany.language))
        }

        if (updateStripeClient) {
          updateSubscriptionPrice(isNotVATLiable)
        }
        return updatedCompany
      }),
    )
  }
}

export const updateVatNumber = (company: CompanyInterface, vatNumber: string): AsyncAction<CompanyPlatformInterface> =>
  actionCreatorAsync<CompanyPlatformInterface>('COMPANY_UPDATE_VAT_NUMBER', () => api.updateCompanyVatNumber(vatNumber))

export const updateInvoicingProfile = (
  company: CompanyPlatformInterface,
  companyName: string,
  businessId: string,
  vatNumber: string,
): AsyncAction<CompanyPlatformInterface> => {
  return actionCreatorAsync<CompanyPlatformInterface>('COMPANY_UPDATE_INVOICING_PROFILE', () =>
    api.updateCompany({ ...company, name: companyName, businessId, vatNumber }),
  )
}

export const initializeCompany = (name: string, language: string, currencyId: number, company: CompanyInterface) => {
  return async (dispatch, getState) => {
    await dispatch(
      actionCreatorAsync<CompanyPlatformInterface>('INITIALIZE_COMPANY', async () => {
        const updatedCompany = await api.updateCompany(
          Object.assign({}, company, {
            name,
            language,
            currencyId,
          }),
        )
        return updatedCompany
      }),
    )
  }
}

export const updateVatNumberValidationAction = actionCreator<VatNumberValidation>(
  CompanyActions.UPDATE_VAT_NUMBER_VALIDATION,
)
